import { render } from "./IncomeProtectionExpressQuestion.vue?vue&type=template&id=2115ae2e&scoped=true"
import script from "./IncomeProtectionExpressQuestion.vue?vue&type=script&lang=js"
export * from "./IncomeProtectionExpressQuestion.vue?vue&type=script&lang=js"

import "./IncomeProtectionExpressQuestion.vue?vue&type=style&index=0&id=2115ae2e&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2115ae2e"]])

export default __exports__